import styled from '@emotion/styled';
import PropTypes from 'prop-types';

const RadioCheck = styled.div`
    position: relative;
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    margin-right: 24px;
    border-radius: 50%;
    box-sizing: border-box;
    border: 1px solid ${({ theme, active }) => active ? theme.primaryColor : theme.borderColor};
    background-color: ${({ theme, active }) => active ? theme.primaryColor : theme.cardColor};

    &::before {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;

      box-sizing: border-box;
      width: 32.5%;
      height: 55%;

      border-right: 2.5px solid ${({ theme }) => theme.cardColor};
      border-bottom: 2.5px solid ${({ theme }) => theme.cardColor};
      transform: translate(-45%, -65%) rotate(45deg);
      display: ${({ active }) => active ? 'block' : 'none'};
    }
    
    @media ${({ theme }) => theme.mobile} {
      margin: 16px 24px 0 16px;
      width: 32px;
      height: 32px;
    }
`;

RadioCheck.propTypes = {
  active: PropTypes.bool,
}

RadioCheck.defaultProps = {
  active: false,
}

export default RadioCheck;
